import { DirectionsRequirement } from '../../types/data';
import { calculatesAverageValue } from '../../utils/utils';

type RowSummaryProps = DirectionsRequirement;

function RowSummary({ title, quarters }: RowSummaryProps) {
  return (
    <>
      <tr>
        <td
          className="border border-gray-400 px-2.5 py-4 text-xs"
          rowSpan={2}
        >
          {title}
        </td>
        <td className="border border-gray-400 px-2.5 py-4 text-xs">
          Все GOP
        </td>
        {quarters.map((element, index) => {
          if (element.blockRequirements === null) {
            return <td key={index} className="border border-gray-400 px-2.5 py-2 text-center text-xs"></td>
          }
          return (
            <td key={index} className="border border-gray-400 px-2.5 py-2 text-center text-xs">
              {calculatesAverageValue(element.blockRequirements, undefined, true)}
              {calculatesAverageValue(element.blockRequirements, undefined, true) !==
                'N/A' && '%'}
            </td>
          )
        })}
      </tr>

      <tr>
        <td className="border border-gray-400 px-2.5 py-4 text-xs">
          Фокусные GOP
        </td>
        {quarters.map((element, index) => {
          if (element.blockRequirements === null) {
            return <td key={index} className="border border-gray-400 px-2.5 py-2 text-center text-xs"></td>
          }
          return (
            <td key={index} className="border border-gray-400 px-2.5 py-2 text-center text-xs">
              {calculatesAverageValue(element.blockRequirements, undefined, true, true)}
              {calculatesAverageValue(element.blockRequirements, undefined, true, true) !==
                'N/A' && '%'}
            </td>
          )
        })}
      </tr>
    </>
  );
}

export default RowSummary;
